import { Injectable, ViewContainerRef } from '@angular/core';
import { CheckInsRequestParam } from 'src/app/utils/interfaces/new/check-ins-request-param';
import { IdentityToCheck } from 'src/app/utils/interfaces/new/identity-to-check';
import { InsIdentityInfos } from 'src/app/utils/interfaces/new/ins-identity-infos.interface';
import { LectureIns } from 'src/app/utils/interfaces/new/lecture-ins.interface';
import { InsServiceAbstract } from './ins-service.abstract';

@Injectable({
  providedIn: 'root'
})
export class InsMockService extends InsServiceAbstract {

  resourceId: string;

  async getInsFromIdentityInformation(view: ViewContainerRef, identityInfos: InsIdentityInfos): Promise<LectureIns> {
    const tableMock = [
      {
        Identity: {
          Ins: {
            s_value: "",
            s_key: "",
            s_oid: "",
            s_startDate: "",
            s_endDate: "",
          },
          s_lastInsiCallDate: "",
          s_birthName: "",
          s_given: "",
          s_birthGiven: "",
          i_sex: 0,
          s_birthDate: "",
          s_birthPlace: "",
          History: [
            {
              s_value: "",
              s_key: "",
              s_oid: "",
              s_startDate: "",
              s_endDate: "",
            }
          ]
        },
        s_status: "OK",
        i_insiIdentityResult: 1,
      },
      {
        Identity: {
          Ins: {
            s_value: "00687312514019810136",
            s_key: "09",
            s_oid: "1.2.250.1.213.1.4.8",
            s_startDate: "2000-09-08",
            s_endDate: "2027-09-08",
          },
          s_lastInsiCallDate: "2001-09-08",
          s_birthName: "BOMBEUR",
          s_given: "JEAN",
          s_birthGiven: "JEAN MARC ALAIN",
          i_sex: 2,
          s_birthDate: "1967-01-15",
          s_birthPlace: "44109",
          History: [
            {
              s_value: "00687312514019810136",
              s_key: "09",
              s_oid: "1.2.250.1.213.1.4.8",
              s_startDate: "2000-09-08",
              s_endDate: "2027-09-08",
            }
          ]
        },
        s_status: "OK",
        i_insiIdentityResult: 2,
      },
      {
        Identity: {
          Ins: {
            s_value: "17984820798138322300",
            s_key: "41",
            s_oid: "1.2.250.1.213.1.4.8",
            s_startDate: "2000-09-08",
            s_endDate: "2027-09-08",
          },
          s_lastInsiCallDate: "2001-09-08",
          s_birthName: "DARK",
          s_given: "JEANNE",
          s_birthGiven: "JEANNE GINETTE LUCIENNE",
          i_sex: 3,
          s_birthDate: "1948-09-22",
          s_birthPlace: "44109",
          History: [
            {
              s_value: "17984820798138322300",
              s_key: "41",
              s_oid: "1.2.250.1.213.1.4.8",
              s_startDate: "2000-09-08",
              s_endDate: "2027-09-08",
            }
          ]
        },
        s_status: "OK",
        i_insiIdentityResult: 3,
      },
    ];
    return tableMock[Math.floor(Math.random() * tableMock.length)] as any;
  }

  getInsFromVitaleCard(view: ViewContainerRef, vitaleIndex: number): Promise<LectureIns>{
    throw new Error('Not implemented');
  }

  checkInsIdentity(view: ViewContainerRef, param: CheckInsRequestParam): Promise<boolean> {
    return new Promise<boolean>((resolve) => resolve(true));
  }

  massCheckInsIdentity(view: ViewContainerRef, param: Array<IdentityToCheck>): Promise<any> {
    return new Promise<any>((resolve) => resolve(undefined));
  }
}
